// libs
import { createContext, useContext } from 'react';

// types
import { LearningContentContextProps } from '../types';

export const LearningContentContext = createContext<LearningContentContextProps | null>(null);

export const useLearningContent = () => {
  const value = useContext(LearningContentContext);

  if (!value) {
    throw new Error('[LearningContentContext] Not initialised');
  }

  return value;
};
